import { render, staticRenderFns } from "./MedicalReport.vue?vue&type=template&id=cf4df5d0&scoped=true&"
import script from "./MedicalReport.vue?vue&type=script&lang=js&"
export * from "./MedicalReport.vue?vue&type=script&lang=js&"
import style0 from "./MedicalReport.vue?vue&type=style&index=0&id=cf4df5d0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4df5d0",
  null
  
)

export default component.exports